import { WretchResponseChain } from 'wretch';
import { errorMessagesAtom, jotaiStore } from '../atoms';
import { coreErrorHandlers, defaultErrorMessages } from '../errors';

export function localizedErrorHandlers<T>(
  instance: WretchResponseChain<T>,
): WretchResponseChain<T> {
  const localizedErrorMessages = jotaiStore.get(errorMessagesAtom);
  return coreErrorHandlers<T>(
    instance,
    localizedErrorMessages || defaultErrorMessages,
  );
}
